import { queryOptions } from '@tanstack/react-query';

import { getAllPreferences } from './user-preferences-api';

/**
 * Every scope's saved preferences: the impersonated user's while
 * impersonating, otherwise your own under `['user-preferences']`, the key the
 * page-order and appearance saves update in place.
 */
export const allPreferencesQuery = (impersonatedUserId: string | null) =>
  queryOptions({
    queryKey: impersonatedUserId
      ? ['user-preferences', impersonatedUserId]
      : ['user-preferences'],
    queryFn: () => getAllPreferences(impersonatedUserId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
